import * as React from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import { classes, useSlug } from '@bloomberg/media-ui-core';
import { TriangleDown, TriangleUp } from '@bloomberg/media-ui-icons';

import styles from './MarketArrow.module.css';

export interface MarketArrowProps extends GlobalProps {
  variant?: 'default' | 'refresh2024';
  delta: number;
  iconClassName?: string;
  width?: number;
  height?: number;
  isDark?: boolean;
}

export const MarketArrow = React.forwardRef<HTMLDivElement, MarketArrowProps>(
  function MarketArrowComponent(props: MarketArrowProps, ref) {
    const {
      name = 'MarketArrow',
      delta,
      iconClassName,
      width,
      height,
      variant,
      isDark = false,
    } = props;
    const componentName = useSlug(name);

    return (
      <div
        className={classes([
          styles.marketArrow,
          {
            [styles.refresh2024]: variant === 'refresh2024',
            [styles.isDark]: isDark,
            [styles.marketUp]: delta > 0,
            [styles.marketDown]: delta < 0,
            [styles.marketNeutral]: delta === 0,
          },
        ])}
        ref={ref}
        data-component={componentName}
      >
        {delta < 0 ? (
          <TriangleDown
            width={width}
            height={height}
            className={iconClassName}
            small
          />
        ) : (
          <TriangleUp
            width={width}
            height={height}
            className={iconClassName}
            small
          />
        )}
      </div>
    );
  }
);
